import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import PropTypes from 'prop-types';
import { Card, Col, Row } from 'react-bootstrap';
import { __APIResponseMessageTypes, __enum_SystemPages, __MessageTypes, __SystemPagesPaths } from '../../../../common/Dictionaries';
import { ConstrainMode, DetailsListLayoutMode, ScrollablePane, ScrollbarVisibility, SelectionMode, ShimmeredDetailsList } from '@fluentui/react';
import { BoardHelpTexts } from '../../../../common/HelpPageText';
import { TeachBubble } from '../../../Templates/TeachBubble';
import MessageBox from '../../../Common/Message/MessageBox';
import { showMessage } from '../../../../common/Helpers';
import { addGapProcess } from '../../../../services/sKPI/gap.service';
import CLabel from '../../../Common/CLabel';
import { createGapAnalyzeProcess } from '../../../../services/sKPI/gap.service';
import { __onGoToGapV2 } from '../../../../common/SystemRedirections';
import { useSelector } from 'react-redux';
import { __OBJECT_STRUCTURE_GetList } from '../../../../common/ObjectStructures/Trasnversal';

const DialogGenerateGap = (props) => {
    const { t } = useTranslation();
    const { _boardStructure: objBoard } = useSelector((state) => state.boardScope);

    const { 
        inputParam_EditMode = false,
        inputParam_IsDialogOpen = null,
        inputParam_SetterIsDialogOpen = null,
        inputParam_GapAnalyzeList = null,

        inputParam_DataserieList = null,
        inputParam_SetDataserieList = null,
        inputParam_SetRevisionList = null,

        inputParam_Element = null,
        inputParam_ProcessPosibleGapsConfig = null,
        inputParam_SetProcessPosibleGapsConfig = null,
        
    } = props;

    const inputParam_BoardName = objBoard !== null ? objBoard.name : "";

    const [messageConfig, setMessageConfig] = useState({
        message : '',
        messageType : __APIResponseMessageTypes.ERROR,
        showMessage : false,
    });
    const [messageConfigRevision, setMessageConfigRevision] = useState({
        message : t('data-lang-msg-selectkpitoprocess'),
        messageType : __APIResponseMessageTypes.INFO,
        showMessage : true,
    });
    
    const [displayFinishButton, setDisplayFinishButton] = useState(true);
    const [dataserieList, setDataserieList] = useState(inputParam_DataserieList.map((item) => ({
        ...item,
        selected: false,
    })));

    const onFinishGenerateGap = () => {
        let itemListToAdd = [];

        dataserieList.forEach(dataserie => {
            if (dataserie.selected) {
                itemListToAdd.push({
                    elementId: dataserie.elementId,
                    dataserieId: dataserie.dataserieId,
                })
            }
        });

        if (itemListToAdd.length > 0) {
            addGapProcess(inputParam_Element.elementId, inputParam_GapAnalyzeList[0].id, itemListToAdd).then((response) => {
                if (response.data.succeeded) {
                    //onDismissDialog()
                    setDisplayFinishButton(false)
                    inputParam_SetDataserieList()

                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, __APIResponseMessageTypes.SUCCESS)
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, __APIResponseMessageTypes.ERROR)
                }
            }).catch((ex) => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, __APIResponseMessageTypes.ERROR)
            });
        }
    }

    const onSwitchLayerView = () => {
        createGapAnalyzeProcess(inputParam_Element.elementId).then((response) => {
            if (response.data.succeeded) {
                if (response.data.succeeded) {
                    inputParam_SetProcessPosibleGapsConfig(prevState => ({
                        ...prevState,
                        eGapAnalyzeElement: true
                    }));
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            }
        }).catch((ex) => {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
        });
    }

    const onDismissDialog = () => {
        inputParam_SetterIsDialogOpen && inputParam_SetterIsDialogOpen()

        setMessageConfig({ message : '', messageType : __APIResponseMessageTypes.ERROR, showMessage : false });

        inputParam_SetDataserieList && inputParam_SetDataserieList(null);
        
        inputParam_SetRevisionList(__OBJECT_STRUCTURE_GetList());

        //setDataserieList(null);
    }

    const handleRadioButtonChange = (item) => {
        const updatedList = dataserieList.map((dataserie) => {
            if (dataserie.id === item.id) {
                return {
                ...dataserie,
                selected: !dataserie.selected,
                };
            }
            return dataserie;
        });
      
        setDataserieList(updatedList);
    };

    return (
        <Dialog
            hidden={!inputParam_IsDialogOpen}
            onDismiss={onDismissDialog}
            styles={{
                main: {
                    selectors: {
                        ['@media (min-width: 468px)']: {
                            width: 400,
                            minWidth: 400,
                        },
                        ['@media (min-width: 768px)']: {
                            width: 700,
                            minWidth: 700,
                        },
                        ['@media (min-width: 992px)']: {
                            width: 810,
                            minWidth: 810,
                        },
                        ['@media (min-width: 1200px)']: {
                            width: 1290,
                            minWidth: 1290,
                        }
                    }
                }
            }}
            dialogContentProps={{
                type: DialogType.normal,
                styles: {header : { borderBottom: "2px solid #e8e8e8" }},
                title: t('data-lang-lbl-processgap'),
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
            {
                inputParam_ProcessPosibleGapsConfig.eGapAnalyzeElement &&
                <>
                    <Row className='mt-1'>
                        <Col>
                            <MessageBox  
                                inputParam_Message={ messageConfig.message }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                            />
                            <MessageBox  
                                inputParam_Message={ messageConfigRevision.message }
                                inputParam_Display={ messageConfigRevision.showMessage }
                                inputParam_MessageType={ messageConfigRevision.messageType }
                                inputParam_SetterMessage={ setMessageConfigRevision }
                            />
                        </Col>
                    </Row>
                    <Row className='pt-2'>
                        <Col xl={12} xs={12}>
                            <CLabel labelText={t('data-lang-lbl-boardname')} labelValue={inputParam_BoardName} />
                        </Col>
                    </Row>
                    <Row className='pt-2'>
                        <Col xs={12} className='pt-2'>
                            <Card className='border rounded-1'>
                                <Card.Header className="card-header-compact border-bottom pt-0">
                                    <Card.Title className="d-flex justify-content-between">
                                        {t('data-lang-boxname-dataserie')}
                                        <div className='toolbar d-flex'>
                                                <TeachBubble
                                                inputParam_ButtonId={ "btnHelpProcessPosibleGaps_Dataserie" }
                                                inputParam_Text={ t(BoardHelpTexts.processPosibleGapsDialog_Dataserie)}
                                                inputParam_Title={ t('data-lang-helptext-title') }
                                            />
                                        </div>
                                    </Card.Title>
                                </Card.Header>
                                <Card.Body>
                                    <ScrollablePane
                                        style={{minHeight: "320px", maxHeight: "100%", height: "100%"}}
                                        styles={{
                                            root: { position: "relative" },
                                            contentContainer:{overflowX: "hidden"}
                                        }}
                                        scrollbarVisibility={ScrollbarVisibility.auto}
                                        scrollContainerFocus={true}
                                    >
                                        <ShimmeredDetailsList
                                            className='list-no-filters no-compact-list'
                                            enableShimmer={!dataserieList}
                                            items={ dataserieList !== null ? dataserieList : [] }
                                            getKey={(...args) => (args[0] ? args[0].id : args[1])}
                                            selectionMode={SelectionMode.none}
                                            layoutMode={DetailsListLayoutMode.justified}
                                            constrainMode={ConstrainMode.unconstrained}
                                            isHeaderVisible={true}
                                            columns={[
                                                {
                                                    key: "id",
                                                    name: '',
                                                    fieldName: "id",
                                                    isResizable: true,
                                                    minWidth: 25,
                                                    maxWidth: 25,
                                                    onRender:(item) => {
                                                        return  <>
                                                                    {
                                                                        !item.hasGapAnalyzeDataserie && 
                                                                            <IconButton
                                                                                iconProps={{ iconName: item.selected ? 'RadioBtnOn' : 'RadioBtnOff' }}
                                                                                checked={item.selected}
                                                                                onClick={() => handleRadioButtonChange(item)}
                                                                            />
                                                                    }
                                                                </>
                                                    }
                                                },
                                                {
                                                    key: "name",
                                                    name: t('data-lang-lbl-data'),
                                                    fieldName: "name",
                                                    isResizable: true,
                                                    onRender:(item) => {
                                                        return  <Row data-id={item.id} style={{borderLeft: `20px solid ${ inputParam_Element.htmlColor !== null && inputParam_Element.htmlColor !== undefined ? inputParam_Element.htmlColor : "" }`}}>
                                                                    <Col>
                                                                        <CLabel labelText={t('data-lang-lbl-name')} labelValue={`${item.name} (${item.um})`}/>
                                                                    </Col>
                                                                </Row>
                                                    }
                                                }
                                            ]}
                                        />
                                    </ScrollablePane>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            }
            {
                !inputParam_ProcessPosibleGapsConfig.eGapAnalyzeElement &&
                <>
                    <Row className='pt-4'>
                        <Col>
                            <Row>
                                <Col>
                                    <h5>{t('data-lang-msg-gapeelementnotfound')}</h5>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="mt-3">
                                    {t('data-lang-msg-cancreategap')}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </>
            }
            <DialogFooter>
                {
                    inputParam_ProcessPosibleGapsConfig.eGapAnalyzeElement &&
                    <>
                        {
                            displayFinishButton &&
                            <PrimaryButton className="me-1" onClick={onFinishGenerateGap} text={t('data-lang-btn-finish')} />
                        }
                        <DefaultButton onClick={onDismissDialog} text={t('data-lang-btn-close')} />
                    </>
                }
                {
                    !inputParam_ProcessPosibleGapsConfig.eGapAnalyzeElement &&
                    <>
                        <PrimaryButton className="me-1" onClick={onSwitchLayerView} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onDismissDialog} text={t('data-lang-lbl-no')} />
                    </>
                }
            </DialogFooter>            
        </Dialog>
    );
};

DialogGenerateGap.propTypes = {
    inputParam_EditMode: PropTypes.bool.isRequired,
    inputParam_IsDialogOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsDialogOpen: PropTypes.func.isRequired,
    inputParam_DataserieList: PropTypes.array,
    inputParam_SetDataserieList: PropTypes.func,
    inputParam_RevisionList: PropTypes.array,
    inputParam_SetRevisionList: PropTypes.func,
    inputParam_Element: PropTypes.object,
    inputParam_GapAnalyzeList: PropTypes.array,
    
    inputParam_ProcessPosibleGapsConfig: PropTypes.object.isRequired,
    inputParam_SetProcessPosibleGapsConfig: PropTypes.func,
};

export default DialogGenerateGap;